import React from "react";

const Answer = ({ handleChange, answer, isSelected }) => {
  return (
    <div className="check_sticky poll">
      <input
        type="checkbox"
        className="checkbox_input"
        value={answer.id}
        checked={isSelected}
        id={`answerid_${answer.id}`}
        onChange={(e) => {
          handleChange(e);
        }}
      />
      <label className="label" htmlFor={`answerid_${answer.id}`}></label>
      <span className="an_answer">{answer.answer}</span>
    </div>
  );
};

export default Answer;
